import Vue from 'vue'
import Router from 'vue-router'
import Login from '../views/LoginPage.vue'
import Home from '../views/HomePage.vue'
import Moblie from '../views/MoblieIndex.vue'
import MoblieLogin from '../views/MoblieLogin.vue'

Vue.use(Router)
const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/login' // 添加根路径重定向到登录页
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/home',
      name: 'Home',
      component: Home,
      meta: { requiresAuth: true, requiresMobile :false }
    },
    {
      path: '/moblie',
      name: 'Moblie',
      component: Moblie,
      meta: { requiresAuth: false, requiresMobile :true }
    },
    {
      path: '/moblielogin',
      name: 'MoblieLogin',
      component: MoblieLogin
    }
  ]
})



router.beforeEach((to, from, next) => {
  if(to.path === '/login')
  {
    if(localStorage.getItem('token'))
    {
      next('/home')
    }else {
      next()
    }
  }else if (to.path === '/moblielogin'){
      if(localStorage.getItem('mobiletoken'))
      {
        next('/moblie')
      }else{
        next()
      }
  }
  else {
    if (to.meta.requiresAuth && !localStorage.getItem('token'))
    {
      next('/login')
    }else if(to.meta.requiresMobile && !localStorage.getItem('mobiletoken')){
      next('/moblielogin')
    }else{
      next()
    }
  }
})


export default router